export default __webpack_public_path__ + "static/media/rentflixT.023ea0e2.png";